import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiUrl, baseUrl } from "../../../utils/apis";
import { ConsultationDetailsResponse, ConsultationsApiItem, ConsultationsPayload, ConsultationsResponse } from "./types";

// Consultation Item Type



export const ConsultationsApiFetching = createApi({
    reducerPath: "ConsultationsApi",
    baseQuery: fetchBaseQuery({
        baseUrl,

        prepareHeaders: (headers) => {
            const token = sessionStorage.getItem("token");

            headers.set("Content-Type", "application/json");

            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }

            return headers;

        },
    }),
    tagTypes: ["consultations"],

    endpoints: (builder) => ({
        getConsultationsList: builder.query<
            ConsultationsResponse,
            {
                search?: string;
                specialization_id?: number | string;
                status?: string;
                consultation_type?: string;
                page: number;
                limit: number;
            }
        >({
            query: (params) => ({
                url: apiUrl.consultations,
                method: "GET",
                params,
            }),
            providesTags: ["consultations"],
        }),


        postConsultations: builder.mutation({
            query: (bodyData: ConsultationsPayload) => ({
                url: apiUrl.consultations,
                method: "POST",
                body: bodyData,
            }),
            invalidatesTags: ["consultations"],
        }),
        updateConsultations: builder.mutation<ConsultationsApiItem, { id: number | string; data: Partial<ConsultationsPayload>, }>({
            query: ({ id, data }) => ({
                url: `${apiUrl.consultations}${id}/`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: "consultations", id },
            ],
        }),
        deleteConsultations: builder.mutation<{ success: boolean; message: string }, string>({
            query: (id) => ({
                url: `${apiUrl.consultations}${id}/`,
                method: "DELETE",
            }),
            invalidatesTags: ["consultations"],
        }),
        getDetailsConsultations: builder.query<
            ConsultationDetailsResponse,
            string | number
        >({
            query: (id) => `${apiUrl.consultations}${id}/`,
            providesTags: (result, error, id) => [
                { type: "consultations", id },
            ],
        }),

    }),
});

export const { useGetConsultationsListQuery, usePostConsultationsMutation, useDeleteConsultationsMutation, useUpdateConsultationsMutation, useGetDetailsConsultationsQuery } = ConsultationsApiFetching;






